<div class="payment" :class="{'payment--mobile': userStore.mobile, 'payment--modal': modal }">
    <h1>{{ $t('modals.payment.title') }}</h1>
    <p v-if="config.Themename === 'camcammer' && modal">{{ $t('payment.desc') }}</p>
    <h2>{{ $t('payment.package-choice') }}</h2>
    <div class="payment__packages">
        <div class="package" v-for="(pack, key) in sortPackages" :class="{'gold': pack.id === 4, 'silver': pack.id === 2, 'bronze': pack.id === 1}">
            <div class="package__content">
                <div class="package__content-title">{{ $t('payment.packages.pack' + pack.id) }}</div>
                <div class="package__content-desc" v-html="$t('payment.package-description', { credits: pack.price, minutes: Math.floor(pack.minutes)})"></div>
            </div>
            <div class="package__choice">
                <span class="btn btn-xsmall btn-grey" v-on:click="editPackages(pack.id, 'remove')">
                    <i class="fa-solid fa-minus"></i>
                </span>
                <span class="package__choice-price">{{ $filters.shortCurrency(pack.price) }}</span>
                <span class="btn btn-xsmall btn-green" v-on:click="editPackages(pack.id, 'add')" :class="{ 'disabled': blockPurchase }">
                    <i class="fa-solid fa-plus"></i>
                </span>
            </div>
            <div class="package__amount">
                <span class="btn btn-xsmall btn-darkgrey">{{ getCurrentAmount(pack.id) }}</span>
            </div>
        </div>
    </div>
    <div class="payment__calculation" v-if="cart">
        <div class="payment__calculation-top">
            <div class="discount">
                <div class="discount__click" @click="showDiscount = !showDiscount" :class="{'up': showDiscount}">{{ $t('payment.discount-desc') }}</div>
                <div class="discount__form" v-if="showDiscount">
                    <form class="form__group" v-if="promo">
                        <input v-model="promoCode" type="text" name="discount" />
                        <button v-on:click.prevent="verifyPromo" class="btn">{{ $t('payment.discount-add') }}</button>
                    </form>
                    <div class="form__group-alert" v-if="promoAlert.message">{{ $t(`${promoAlert.message}`) }}</div>
                </div>
            </div>
            <div class="subtotal">
                <div class="subtotal-amount">
                    <span>{{ $t('payment.subtotal') }}</span>
                    <span>{{ $filters.niceCredits(credits) }}</span>
                </div>
                <div class="subtotal-bonus">
                    <span>{{ $t('payment.bonuscredits') }}</span>
                    <span>{{ $filters.niceCredits(getBonus) }}</span>
                </div>
                <div class="subtotal-credits">
                    <span>{{ $t('payment.totalcredits') }}</span>
                    <span>{{ $filters.niceCredits(credits + getBonus + promoCredits) }}</span>
                </div>
            </div>
        </div>
        <div class="payment__calculation-bottom">
            <div class="reset">
                <span class="btn btn-xsmall btn-grey btn-nohover mr hidden-xs" v-if="nextBonus && marketing && !marketing.current">{{ $t('payment.bonusbanner', { credits: nextBonus.amount, percentage: nextBonus.percentage }) }}</span>
                <a class="btn btn-xsmall" v-on:click="clearCart()">{{ $t('payment.reset') }}</a>
            </div>
            <div class="total">
                <span>{{ $t('payment.total') }}</span>
                <span>{{ $filters.shortCurrency(total) }}</span>
            </div>
        </div>
    </div>
    <h2>{{ $t('payment.methods-choice') }}</h2>
    <div class="payment__methodes" v-if="getMethods">
        <div class="methode" v-for="paymentMethod in getMethods" :class="{ 'active': paymentMethod.abbr === selectedPayment }">
            <div class="methode__selection" v-on:click="selectPayment(paymentMethod.abbr)">
                <div class="methode__radio">
                    <span></span>
                </div>
                <div class="methode__name">
                    <p v-html="$t('payment.methods.' + paymentMethod.info)"></p>
                    <i v-if="!paymentMethod.addBonus">*</i>
                </div>
                <div class="methode__image paymentIcons" :class="paymentMethod.abbr.replace(/\//g, '-')" :title="paymentMethod.abbr">
                    <span></span>
                </div>
            </div>
            <div class="methode__issuers" v-if="paymentMethod.issuers && paymentMethod.abbr === selectedPayment">
                <div class="methode__issuers-form">
                    <div class="form__group">
                        <select @change="issuerChange($event)">
                            <option :value="'undefined'">{{ $t('payment.choicebank') }}</option>
                            <option v-for="is in paymentMethod.issuers" :value="is.id">{{ is.name }}</option>
                        </select>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="payment__methodes-desc" v-if="config.Themename !== 'camcammer'">{{ $t('payment.bonusdiscountdesc') }}</div>
    <div class="payment__finish">
        <button class="btn btn-green btn-large" :disabled="!paymentDisabled" :class="{ 'disabled': (!paymentDisabled || !canBuy) }" v-on:click="submitPurchase()">{{ $t('payment.paying') }}</button>
    </div>
</div>